export default __webpack_public_path__ + "static/media/card3.bd813e33.png";